import Progressbar from "./progress-bar";

export default Progressbar